<template>
  <div>
    <el-card header="SCORECARD EVENT" shadow="never" class="mt-24">
      <el-row :gutter="24">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <span>Scorecard Name：</span>
          <el-select
            v-model="scoreCardId"
            style="width: 340px; margin-top: 10px"
            @change="handleScoreChange"
          >
            <el-option
              v-for="item in scoreNameList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            />
          </el-select>
        </el-col>
        <el-col
          :lg="12"
          :md="12"
          :sm="24"
          :xs="24"
          v-if="!['SC01', 'SC18', 'SC19'].includes(this.scoreIndex)"
        >
          <span>Financial Year：</span>
          <el-date-picker
            style="width: 340px; margin-top: 10px"
            v-model="financialYear"
            value-format="yyyy"
            type="year"
            :clearable="false"
            @change="_getFRisk"
          />
        </el-col>
      </el-row>
    </el-card>
    <el-card
      v-show="scoreIndex === 'SC08'"
      header="EVENT DATA"
      shadow="never"
      class="mt-24"
    >
      <el-form :model="form1" ref="form1" :rules="rules8" label-position="top">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="PAYMENT EXPERIENCE" prop="paymentExperience">
              <el-select v-model="form1.paymentExperience">
                <el-option
                  v-for="item in this.paymentList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="FRISK SCORE" prop="friskScore">
              <el-select v-model="form1.friskScore">
                <el-option label="NR" :value="0"></el-option>
                <el-option
                  v-for="(item, index) in new Array(10)"
                  :label="index + 1"
                  :value="index + 1"
                  :key="index + 1"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item
              label="REGIONAL DIVERSIFICATION"
              prop="regionalDiversification"
            >
              <el-select v-model="form1.regionalDiversification">
                <el-option
                  v-for="item in this.commonList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="KEY CLIENT" prop="keyClient">
              <el-select v-model="form1.keyClient">
                <el-option
                  v-for="item in this.commonList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="YEARS IN BUSINESS" prop="yearsInBusiness">
              <el-select v-model="form1.yearsInBusiness">
                <el-option
                  v-for="item in this.commonList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <div class="grid-content bg-purple">
              <el-form-item
                label="PRODUCT DIVERSIFICATION"
                prop="productDiversification"
              >
                <el-select v-model="form1.productDiversification">
                  <el-option
                    v-for="item in this.commonList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="MARKET POSITION" prop="marketPosition">
              <el-select v-model="form1.marketPosition">
                <el-option
                  v-for="item in this.commonList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="OTHER" prop="other">
              <el-select v-model="form1.other">
                <el-option
                  v-for="item in this.commonList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card
      v-show="scoreIndex === 'SC09'"
      header="EVENT DATA"
      shadow="never"
      class="mt-24"
    >
      <el-form :model="form2" ref="form2" label-position="top" :rules="rules9">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="S & P">
              <el-select v-model="form2.sp">
                <el-option
                  v-for="item in this.fitchList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="MOODY'S">
              <el-select v-model="form2.moodys">
                <el-option
                  v-for="item in this.moodyList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="FITCH">
              <el-select v-model="form2.fitch">
                <el-option
                  v-for="item in this.fitchList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <template>
            <el-col :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item label="Current Asset" prop="currentAsset">
                <el-input v-model="form2.currentAsset" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item label="Current Liability" prop="currentLiability">
                <el-input v-model="form2.currentLiability" />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item label="Equity" prop="equity">
                <el-input v-model="form2.equity" />
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </el-card>
    <el-card
      v-show="scoreIndex === 'SC16'"
      header="EVENT DATA"
      shadow="never"
      class="mt-24"
    >
      <el-form :model="form3" ref="form3" label-position="top" :rules="rules3">
        <el-row :gutter="24">
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Data Source:" prop="dataSource">
              <el-select v-model="form3.dataSource" style="width: 100%">
                <el-option label="Public Rating Agency" :value="1" />
                <el-option label="Financial Report" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              v-if="form3.dataSource === 2"
              label="Business Type"
              prop="businessType"
            >
              <el-select v-model="form3.businessType" style="width: 100%">
                <el-option label="DS" :value="1" />
                <el-option label="BP" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card
      v-show="scoreIndex === 'SC18'"
      header="EVENT DATA"
      shadow="never"
      class="mt-24"
    >
      <el-form :model="form4" ref="form4" label-position="top" :rules="rules4">
        <div style="margin: 40px 0 40px 0">
          <el-divider content-position="left">
            <p style="font-size: 20px; font-weight: bold">Basic Information</p>
          </el-divider>
        </div>
        <el-row :gutter="24">
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Customer Type" prop="customerType">
              <el-select v-model="form4.customerType" placeholder="Select">
                <el-option label="Bank" value="1"></el-option>
                <el-option label="No Bank" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Company Type" prop="companyType">
              <el-select v-model="form4.companyType" placeholder="Select">
                <el-option label="Private" value="1"></el-option>
                <el-option label="Public" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="DS Type" prop="dsType">
              <el-select v-model="form4.dsType" placeholder="Select">
                <el-option label="GA" value="1"></el-option>
                <el-option label="Local DS" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Financial Statement Date"
              prop="financialStatementeDate"
            >
              <el-date-picker
                style="width: 100%"
                v-model="form4.financialStatementeDate"
                type="date"
                placeholder="Select date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="handleCurrencyChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Financial Statement Currency"
              prop="financialStatementCurrency"
            >
              <el-select
                filterable
                v-model="form4.financialStatementCurrency"
                placeholder="Select"
                @change="handleCurrencyChange"
              >
                <el-option
                  :label="item.currencyName"
                  :value="item.currency"
                  v-for="item in currencyList"
                  :key="item.currency"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Type of Request">
              <el-select
                disabled
                v-model="form4.typeOfRequest"
                placeholder="Select"
              >
                <el-option label="New Customer" value="1"></el-option>
                <el-option label="Existing Customer" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Required CL - USD" prop="requiredCL">
              <el-input
                v-model="form4.requiredCL"
                @focus="
                  value => handleInput(form4.requiredCL, 'form4', 'requiredCL')
                "
                @blur="
                  () => handleBlur(form4.requiredCL, 'form4', 'requiredCL')
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :lg="12"
            :md="24"
            :sm="24"
            :xs="24"
            v-if="form4.financialStatementCurrency !== 'USD'"
          >
            <el-form-item label="Exchange Rate">
              <el-input v-model="form4.exchangeRate" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="margin: 100px 0 40px 0">
          <el-divider content-position="left">
            <p style="font-size: 20px; font-weight: bold">
              AR, Backlog and Exposure Status
            </p>
          </el-divider>
        </div>
        <el-row :gutter="24">
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Total AR (Actuals)">
              <el-input
                disabled
                :value="this.companyInfo?.customerAr?.arAmount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Backlog">
              <el-input
                disabled
                :value="this.companyInfo?.customerAr?.amountBacklog"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Total Exposure">
              <el-input
                disabled
                :value="this.companyInfo?.customerAr?.totalExposure"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Current AR">
              <el-input
                disabled
                :value="this.companyInfo?.customerAr?.currentBucket"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Past Due AR < 30 days">
              <el-input
                disabled
                :value="this.companyInfo?.customerAr?.overdueOne"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Past Due AR  31-60 days">
              <el-input
                disabled
                :value="this.companyInfo?.customerAr?.overdueThirty"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Past Due AR > 60 days">
              <el-input
                disabled
                :value="
                  Object.keys(this.companyInfo).length &&
                  numeral(this.companyInfo?.customerAr?.overdueSixty || 0)
                    .add(
                      this.companyInfo?.customerAr?.overdueHundredEighty || 0,
                    )
                    .add(this.companyInfo?.customerAr?.overdueNinety || 0)
                    .value()
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="margin: 100px 0 40px 0">
          <el-divider content-position="left">
            <p style="font-size: 20px; font-weight: bold">
              Business Background
            </p>
          </el-divider>
        </div>
        <el-row :gutter="24">
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Working years with Lenovo"
              prop="workingYearsWithLenovo"
            >
              <el-date-picker
                style="width: 100%"
                v-model="form4.workingYearsWithLenovo"
                type="date"
                placeholder="Select date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Established (Year)" prop="established">
              <el-date-picker
                style="width: 100%"
                v-model="form4.established"
                type="year"
                format="yyyy"
                value-format="yyyy"
                placeholder="Select Year"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Number of Employees" prop="numberOfEmployees">
              <el-input
                type="number"
                v-model="form4.numberOfEmployees"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Coface Report Available"
              prop="cofaceReportAvailable"
            >
              <el-select
                v-model="form4.cofaceReportAvailable"
                placeholder="Select"
                @change="
                  value => {
                    if (value === '2') {
                      form4.cofaceRecommendedMaximumCL = 0
                    } else {
                      form4.cofaceRecommendedMaximumCL = ''
                    }
                  }
                "
              >
                <el-option label="Yes" value="1"></el-option>
                <el-option label="No" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="COFACE Commercial Score (Keep it empty if NO report available)"
              prop="cofaceCommercialScore"
            >
              <el-select
                v-model="form4.cofaceCommercialScore"
                placeholder="Select"
                :disabled="calcScore"
              >
                <el-option
                  v-for="item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                  :label="item"
                  :value="item"
                  :key="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="COFACE Recommended Maximum CL (Keep it empty if NO report available)"
              prop="cofaceRecommendedMaximumCL"
            >
              <el-input
                :disabled="form4.cofaceReportAvailable === '2'"
                v-model="form4.cofaceRecommendedMaximumCL"
                @focus="
                  value =>
                    handleInput(
                      form4.cofaceRecommendedMaximumCL,
                      'form4',
                      'cofaceRecommendedMaximumCL',
                    )
                "
                @blur="
                  () =>
                    handleBlur(
                      form4.cofaceRecommendedMaximumCL,
                      'form4',
                      'cofaceRecommendedMaximumCL',
                    )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="margin: 100px 0 40px 0">
          <el-divider content-position="left">
            <p style="font-size: 20px; font-weight: bold">Financial Analysis</p>
          </el-divider>
        </div>
        <el-row :gutter="24">
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Short Term Assets Local Currency (Millions)"
              prop="totalShortTermAssets"
            >
              <el-input
                v-model="form4.totalShortTermAssets"
                @focus="
                  value =>
                    handleInput(
                      form4.totalShortTermAssets,
                      'form4',
                      'totalShortTermAssets',
                    )
                "
                @blur="
                  () =>
                    handleBlur(
                      form4.totalShortTermAssets,
                      'form4',
                      'totalShortTermAssets',
                    )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Long Term Assets Local Currency (Millions)"
              prop="totalLongTermAssets"
            >
              <el-input
                v-model="form4.totalLongTermAssets"
                @focus="
                  value =>
                    handleInput(
                      form4.totalLongTermAssets,
                      'form4',
                      'totalLongTermAssets',
                    )
                "
                @blur="
                  () =>
                    handleBlur(
                      form4.totalLongTermAssets,
                      'form4',
                      'totalLongTermAssets',
                    )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Assets Local Currency (Millions)"
              prop="totalAssets"
            >
              <el-input v-model="form4.totalAssets" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Short Term Liabilities Local Currency (Millions)"
              prop="totalShortTermLiabilities"
            >
              <el-input
                v-model="form4.totalShortTermLiabilities"
                @focus="
                  value =>
                    handleInput(
                      form4.totalShortTermLiabilities,
                      'form4',
                      'totalShortTermLiabilities',
                    )
                "
                @blur="
                  () =>
                    handleBlur(
                      form4.totalShortTermLiabilities,
                      'form4',
                      'totalShortTermLiabilities',
                    )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Long Term Liabilities Local Currency (Millions)"
              prop="totalLongTermLiabilities"
            >
              <el-input
                v-model="form4.totalLongTermLiabilities"
                @focus="
                  value =>
                    handleInput(
                      form4.totalLongTermLiabilities,
                      'form4',
                      'totalLongTermLiabilities',
                    )
                "
                @blur="
                  () =>
                    handleBlur(
                      form4.totalLongTermLiabilities,
                      'form4',
                      'totalLongTermLiabilities',
                    )
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Liabilities Local Currency (Millions)"
              prop="totalLiabilities"
            >
              <el-input v-model="form4.totalLiabilities" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Net Worth Local Currency (Millions)"
              prop="totalNetWorth"
            >
              <el-input v-model="form4.totalNetWorth" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Total Revenue Local Currency (Millions)"
              prop="totalRevenue"
            >
              <el-input
                v-model="form4.totalRevenue"
                @focus="
                  value =>
                    handleInput(form4.totalRevenue, 'form4', 'totalRevenue')
                "
                @blur="
                  () => handleBlur(form4.totalRevenue, 'form4', 'totalRevenue')
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Net Profit Local Currency (Millions)"
              prop="netProfit"
            >
              <el-input
                v-model="form4.netProfit"
                @focus="
                  value => handleInput(form4.netProfit, 'form4', 'netProfit')
                "
                @blur="() => handleBlur(form4.netProfit, 'form4', 'netProfit')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card
      v-show="scoreIndex === 'SC19'"
      header="EVENT DATA"
      shadow="never"
      class="mt-24"
    >
      <el-form :model="form5" ref="form5" label-position="top" :rules="rules5">
        <el-row :gutter="24">
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Commercial Registry/Business Started"
              prop="businessStarted"
            >
              <el-select v-model="form5.businessStarted" placeholder="Select">
                <el-option label="More than 10 years" value="1"></el-option>
                <el-option label="Less than 10 years" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Existing Customer" prop="existingCustomer">
              <el-select
                v-model="form5.existingCustomer"
                placeholder="Select"
                disabled
              >
                <el-option label="Yes" value="1"></el-option>
                <el-option label="No" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Number of Employees" prop="numberOfEmployees">
              <el-select v-model="form5.numberOfEmployees" placeholder="Select">
                <el-option label="50 or More" value="1"></el-option>
                <el-option label="Less than 50" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Free of Legal Events" prop="freeOfLegalEvents">
              <el-select v-model="form5.freeOfLegalEvents" placeholder="Select">
                <el-option label="Yes" value="1"></el-option>
                <el-option label="No" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item label="Coface Credit Score" prop="cofaceCreditScore">
              <el-select v-model="form5.cofaceCreditScore" placeholder="Select">
                <el-option label="5 or More" value="1"></el-option>
                <el-option label="Less than 5" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24" :sm="24" :xs="24">
            <el-form-item
              label="Overdue + 60 days (5K or More)"
              prop="overdueSixty"
            >
              <el-select
                v-model="form5.overdueSixty"
                placeholder="Select"
                disabled
              >
                <el-option label="No" value="1"></el-option>
                <el-option label="Yes" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div class="btn-wrapper">
      <customize-button style="margin-right: 20px" @click="$router.go(-1)">
        Cancel
      </customize-button>
      <customize-button type="primary" @click="handleSubmit">
        Submit Event
      </customize-button>
    </div>
  </div>
</template>

<script>
import { getCurrencyList, getSelectList } from '@/api'
import {
  calcScoreCard,
  getInfo09,
  getFRisk,
  getThreeValue,
  getCompanyInfo,
  getCurrenyRate,
} from './api'
import numeral from 'numeral'
import _ from 'lodash'

export default {
  data() {
    this.paymentList = [
      { id: 1, name: 'New Client' },
      { id: 2, name: 'CONSISTENTLY ON TIME' },
      { id: 3, name: 'OCCASSIONALLY PAST DUE 1-30 DAYS' },
      { id: 4, name: 'CONSISTENTLY PAST DUE 1-30 DAYS' },
      { id: 5, name: 'OCCASSIONALLY PAST DUE 31-60 DAYS' },
      { id: 6, name: 'CONSISTENTLY PAST DUE 31-60 DAYS' },
      { id: 7, name: 'OCCASSIONALLY PAST DUE 61-90 DAYS' },
      { id: 8, name: 'CONSISTENTLY PAST DUE 61-90 DAYS' },
      { id: 9, name: 'OCCASSIONALLY PAST DUE 90+ DAYS' },
      { id: 10, name: 'CONSISTENTLY PAST DUE 90+ DAYS' },
    ]
    this.commonList = [
      { id: 1, name: 'High' },
      { id: 2, name: 'Medium' },
      { id: 3, name: 'Low' },
    ]
    this.fitchList = [
      { id: 1, name: 'AAA' },
      { id: 2, name: 'AA+' },
      { id: 3, name: 'AA' },
      { id: 4, name: 'AA-' },
      { id: 5, name: 'A+' },
      { id: 6, name: 'A' },
      { id: 7, name: 'A-' },
      { id: 8, name: 'BBB+' },
      { id: 9, name: 'BBB' },
      { id: 10, name: 'BBB-' },
      { id: 11, name: 'BB+' },
      { id: 12, name: 'BB' },
      { id: 13, name: 'BB-' },
      { id: 14, name: 'B+' },
      { id: 15, name: 'B' },
      { id: 16, name: 'B-' },
      { id: 17, name: 'CCC+' },
      { id: 18, name: 'CCC' },
      { id: 19, name: 'CCC-' },
      { id: 20, name: 'CC' },
      { id: 21, name: 'C' },
      { id: 22, name: 'D' },
      { id: 23, name: 'NR' },
    ]
    this.moodyList = [
      { id: 1, name: 'Aaa' },
      { id: 2, name: 'Aa1' },
      { id: 3, name: 'Aa2' },
      { id: 4, name: 'Aa3' },
      { id: 5, name: 'A1' },
      { id: 6, name: 'A2' },
      { id: 7, name: 'A3' },
      { id: 8, name: 'Baa1' },
      { id: 9, name: 'Baa2' },
      { id: 10, name: 'Baa3' },
      { id: 11, name: 'Ba1' },
      { id: 12, name: 'Ba2' },
      { id: 13, name: 'Ba3' },
      { id: 14, name: 'B1' },
      { id: 15, name: 'B2' },
      { id: 16, name: 'B3' },
      { id: 17, name: 'Caa1' },
      { id: 18, name: 'Caa2' },
      { id: 19, name: 'Caa3' },
      { id: 20, name: 'Ca1' },
      { id: 21, name: 'Ca2' },
      { id: 22, name: 'C' },
      { id: 23, name: 'NR' },
    ]
    return {
      scoreNameList: [],
      financialYear: '',
      scoreCardId: '',
      form1: {
        paymentExperience: '',
        friskScore: '',
        regionalDiversification: '',
        keyClient: '',
        yearsInBusiness: '',
        productDiversification: '',
        marketPosition: '',
        other: '',
        financialYear: '',
        id: '',
      },
      form2: {
        fitch: '',
        moodys: '',
        sp: '',
        financialYear: '',
        id: '',
        currentAsset: '',
        currentLiability: '',
        equity: '',
      },
      form3: { dataSource: '', businessType: '' },
      rules8: {
        paymentExperience: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        friskScore: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        regionalDiversification: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        keyClient: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        yearsInBusiness: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        productDiversification: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        marketPosition: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        other: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      rules3: {
        dataSource: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        businessType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      rules9: {
        currentAsset: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        currentLiability: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        equity: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      form4: {
        customerType: '',
        dsType: '',
        financialStatementCurrency: '',
        requiredCL: '',
        companyType: '',
        financialStatementeDate: '',
        typeOfRequest: '',
        exchangeRate: '',
        //------------
        totalExposure: '',
        currentAR: '',
        overdueOne: '',
        overdueThirty: '',
        overdueSixty: '',
        //------------
        workingYearsWithLenovo: '',
        established: '',
        numberOfEmployees: '',
        cofaceReportAvailable: '',
        cofaceCommercialScore: 0,
        cofaceRecommendedMaximumCL: '',
        //------------
        totalShortTermAssets: '',
        totalLongTermAssets: '',
        totalAssets: '',
        totalShortTermLiabilities: '',
        totalLongTermLiabilities: '',
        totalLiabilities: '',
        totalNetWorth: '',
        totalRevenue: '',
        netProfit: '',
      },
      rules4: {
        customerType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        companyType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        dsType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        financialStatementeDate: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        financialStatementCurrency: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        requiredCL: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        //--------
        workingYearsWithLenovo: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        established: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        cofaceReportAvailable: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        cofaceCommercialScore: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        numberOfEmployees: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        cofaceRecommendedMaximumCL: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        //--------
        totalShortTermAssets: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalLongTermAssets: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalAssets: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalShortTermLiabilities: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalLongTermLiabilities: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalLiabilities: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalNetWorth: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        totalRevenue: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        netProfit: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      form5: {
        businessStarted: '',
        numberOfEmployees: '',
        cofaceCreditScore: '',
        existingCustomer: '',
        freeOfLegalEvents: '',
        overdueSixty: '',
      },
      rules5: {
        businessStarted: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        numberOfEmployees: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        cofaceCreditScore: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        existingCustomer: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        freeOfLegalEvents: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        overdueSixty: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      currencyList: [],
      companyInfo: {},
      calcScore: true,
    }
  },
  computed: {
    scoreIndex() {
      const res = this.scoreNameList.filter(
        item => item.id === this.scoreCardId,
      )
      return res.length ? res[0].mark : ''
    },
  },
  mounted() {
    this.companyId = this.$route.params.customerId
    this._getSelectList()
    this._getCompanyInfo()
    this._getCurrencyList()
    const amount = this.$route.query.amount
    if (amount) this.form4.requiredCL = amount
  },
  watch: {
    'form4.companyType'() {
      this.updateCofaceCommercialScore()
    },
    'form4.cofaceReportAvailable'() {
      this.updateCofaceCommercialScore()
    },
    'form4.totalShortTermAssets'() {
      this.computed1()
    },
    'form4.totalLongTermAssets'() {
      this.computed1()
    },
    'form4.totalShortTermLiabilities'() {
      this.computed2()
      this.computed3()
    },
    'form4.totalLongTermLiabilities'() {
      this.computed2()
    },
    'form4.totalAssets'() {
      this.computed3()
    },
    'form4.totalLiabilities'() {
      this.computed3()
    },
  },
  methods: {
    handleInput(value, form, key) {
      this[form][key] = numeral(value).value() || value
    },
    handleBlur(value, form, key) {
      this[form][key] = numeral(value).format('0,0.00')
    },
    computed1() {
      this.form4.totalAssets = numeral(this.form4.totalShortTermAssets || 0)
        .add(numeral(this.form4.totalLongTermAssets).value() || 0)
        .format('0,0.00')
    },
    computed2() {
      this.form4.totalLiabilities = numeral(
        this.form4.totalShortTermLiabilities || 0,
      )
        .add(numeral(this.form4.totalLongTermLiabilities).value() || 0)
        .format('0,0.00')
    },
    computed3() {
      // console.log(numeral(this.form4.totalAssets).value(), 1111)
      // console.log(numeral(this.form4.totalLiabilities).value(), 2222)
      this.form4.totalNetWorth = numeral(this.form4.totalAssets || 0)
        .subtract(numeral(this.form4.totalLiabilities).value() || 0)
        .format('0,0.00')
    },
    numeral,
    updateCofaceCommercialScore() {
      const { companyType, cofaceReportAvailable } = this.form4

      // 默认情况下设置calcScore为true，只有特定情况下才设置为false
      this.calcScore = true

      if (cofaceReportAvailable === '1') {
        this.form4.cofaceCommercialScore = ''
        this.calcScore = false
      } else if (cofaceReportAvailable === '2') {
        // 使用条件运算符简化逻辑
        this.form4.cofaceCommercialScore =
          companyType === '1' ? 4 : companyType === '2' ? 6 : 0
      } else {
        this.form4.cofaceCommercialScore = 0
      }
    },
    async handleCurrencyChange() {
      const { financialStatementeDate, financialStatementCurrency } = this.form4
      if (financialStatementeDate && financialStatementCurrency) {
        if (financialStatementCurrency !== 'USD') {
          const res = await getCurrenyRate(
            financialStatementeDate,
            financialStatementCurrency,
          )
          this.form4.exchangeRate = res.rate
        }
      }
    },
    async _getCompanyInfo() {
      const res = await getCompanyInfo(this.$route.params.customerId)
      this.companyInfo = res
      if (res?.companyDetailVO?.gln || res?.companyDetailVO?.iln) {
        this.form4.dsType = '1'
      } else {
        this.form4.dsType = '2'
      }

      if (res?.totalArBalance != null && res?.totalArBalance !== 0) {
        this.form4.typeOfRequest = '2'
      } else {
        this.form4.typeOfRequest = '1'
      }

      this.form4.workingYearsWithLenovo = res.companyInfoVO.signDate

      if (this.companyInfo?.totalArBalance === 0) {
        this.form5.existingCustomer = '2'
      } else {
        this.form5.existingCustomer = '1'
      }

      const overdueSixty = this.companyInfo?.customerAr?.overdueSixty || 0
      const overdueNinety = this.companyInfo?.customerAr?.overdueNinety || 0
      const overdueHundredEighty =
        this.companyInfo?.customerAr?.overdueHundredEighty || 0

      const total = numeral(overdueSixty || 0)
        .add(overdueNinety)
        .add(overdueHundredEighty)
        .value()

      if (total >= 5000) {
        this.form5.overdueSixty = '2'
      } else {
        this.form5.overdueSixty = '1'
      }
    },
    async _getCurrencyList() {
      const res = await getCurrencyList()
      this.currencyList = res
    },
    async _getFRisk() {
      this.form1.friskScore = await getFRisk(this.companyId, this.financialYear)
      const { companyFinanceBalance } = await getThreeValue(
        this.companyId,
        this.financialYear,
      )
      if (companyFinanceBalance) {
        this.form2.currentAsset = this.$utils.formatAmount(
          companyFinanceBalance.c34,
        )
        this.form2.currentLiability = this.$utils.formatAmount(
          companyFinanceBalance.c80,
        )
        this.form2.equity = this.$utils.formatAmount(companyFinanceBalance.c106)
      }
    },
    async _getSelectList() {
      try {
        this.scoreNameList = await getSelectList('ScoreCard')
      } catch (err) {
        console.error(err)
      }
    },
    async handleScoreChange() {
      if (this.scoreIndex === 'SC09') {
        await this._getSC09Info()
      }
      // if (this.scoreIndex === 'SC16') {
      //   this.showSC16 = true
      // }
    },
    async _getSC09Info() {
      try {
        const { detail } = await getInfo09(this.companyId)
        Object.keys(this.form2).forEach(key => {
          this.form2[key] = detail[key]
        })
      } catch (err) {
        console.error(err)
      }
    },
    async handleSubmit() {
      if (!this.scoreCardId) {
        return this.$message.warning('Please select Scorecard Name')
      }

      if (
        !this.financialYear &&
        !['SC01', 'SC18', 'SC19'].includes(this.scoreIndex)
      ) {
        return this.$message.warning('Please select financialYear')
      }

      let submitData = { financialYear: this.financialYear }
      if (this.scoreIndex === 'SC08') {
        await this.$refs.form1.validate()
        submitData.creditScoreCardMotorolaNonBO = {
          ...this.form1,
          companyId: this.companyId,
          financialYear: this.financialYear,
        }
      } else if (this.scoreIndex === 'SC09') {
        await this.$refs.form2.validate()
        this.form2.currentAsset = this.$utils.resetAmount(
          this.form2.currentAsset,
        )
        this.form2.currentLiability = this.$utils.resetAmount(
          this.form2.currentLiability,
        )
        this.form2.equity = this.$utils.resetAmount(this.form2.equity)
        submitData.creditScoreCardMotorolaBO = {
          ...this.form2,
          companyId: this.companyId,
          financialYear: this.financialYear ? this.financialYear : '1',
        }
      } else if (this.scoreIndex === 'SC16') {
        submitData.dataSource = this.form3.dataSource
        submitData.businessType = this.form3.businessType
        submitData.creditScoreCardMotorolaBO = {
          companyId: this.companyId,
          financialYear: this.financialYear,
        }
      }

      if (this.scoreIndex === 'SC18') {
        const valid = await this.$refs.form4.validate()
        console.log(this.form4)
        if (valid) {
          let creditScoreCardLASBO = _.cloneDeep(this.form4)
          for (const key in creditScoreCardLASBO) {
            if (
              [
                'requiredCL',
                'exchangeRate',
                'cofaceRecommendedMaximumCL',
                'totalShortTermAssets',
                'totalLongTermAssets',
                'totalAssets',
                'totalShortTermLiabilities',
                'totalLongTermLiabilities',
                'totalLiabilities',
                'totalNetWorth',
                'totalRevenue',
                'netProfit',
              ].includes(key)
            ) {
              creditScoreCardLASBO[key] = numeral(
                creditScoreCardLASBO[key],
              ).value()
            }
          }
          submitData = {
            companyId: this.companyId,
            scoreCardId: this.scoreCardId,
            creditScoreCardLASBO,
          }
        }
      }

      if (this.scoreIndex === 'SC19') {
        const valid = await this.$refs.form5.validate()
        if (valid) {
          submitData = {
            companyId: this.companyId,
            scoreCardId: this.scoreCardId,
            creditScoreCardQCLASBO: this.form5,
          }
        }
      }
      await this.commonSave(submitData)
    },
    async commonSave(submitData) {
      await calcScoreCard({
        companyId: this.companyId,
        scoreCardId: this.scoreCardId,
        ...submitData,
      })
      this.$message.success('success')
      this.$router.push(`/customer-management/${this.companyId}/scores`)
      // this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="scss">
.btn-wrapper {
  text-align: right;
}
:deep(.el-select) {
  width: 100%;
}
</style>
